import React, { FC, useState } from 'react';
import { Button, Icon } from '@kontentino/ui';
import { faCreditCard } from '@fortawesome/pro-light-svg-icons/faCreditCard';
import { useOpenBillingPage } from 'app/hooks/useBillingUrl';
import { useTranslation } from 'react-i18next';
type Props = {
  daysLeft: number;
};

const TrialDaysLeftButton: FC<Props> = ({ daysLeft }) => {
  const [isHovered, setHovered] = useState(false);
  const { t } = useTranslation();
  const openBillingPage = useOpenBillingPage();

  return (
    <Button
      variant="special"
      className="tw-hidden tw-h-[36px] tw-whitespace-nowrap md:tw-flex"
      iconBefore={isHovered && <Icon icon={faCreditCard} />}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => openBillingPage()}
    >
      {isHovered
        ? t('trialDaysLeft.buyNow')
        : t('trialDaysLeft.daysLeft', { count: daysLeft })}
    </Button>
  );
};

export default TrialDaysLeftButton;
